import { render } from "./DamageEdit.vue?vue&type=template&id=54a40268&scoped=true"
import script from "./DamageEdit.vue?vue&type=script&lang=js"
export * from "./DamageEdit.vue?vue&type=script&lang=js"

import "./DamageEdit.vue?vue&type=style&index=0&id=54a40268&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54a40268"]])

export default __exports__